const Vue = require('vue')

const { plural } = require('sci/utils')

Vue.component('property-media', {
    props: {
        property: {
            twoWay: true,
            type: Object,
            default: null
        },
        width: {
            type: String,
            default: '90px'
        }
    },
    computed: {
        photosLabel () {
            return plural(this.property.photos.length, '%s foto', '%s fotos', 'nenhuma foto')
        },
        videosLabel () {
            return plural(this.property.videos.length, '%s vídeo', '%s vídeos', 'nenhum vídeo')
        },
        label () {
            return `${this.photosLabel} / ${this.videosLabel}`
        }
    },
    template: require('templates/components/ui-property-media.html')
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui-property-media.js